import { render, staticRenderFns } from "./report-grid.vue?vue&type=template&id=03fb910f&scoped=true"
import script from "./report-grid.vue?vue&type=script&lang=ts"
export * from "./report-grid.vue?vue&type=script&lang=ts"
import style0 from "./report-grid.vue?vue&type=style&index=0&id=03fb910f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb910f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fb910f')) {
      api.createRecord('03fb910f', component.options)
    } else {
      api.reload('03fb910f', component.options)
    }
    module.hot.accept("./report-grid.vue?vue&type=template&id=03fb910f&scoped=true", function () {
      api.rerender('03fb910f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/report-grid/report-grid.vue"
export default component.exports